import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import {FormGroup, FormControl} from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { EventService } from 'src/app/services/event.service';
import { UserData } from 'src/app/models/user-data.models';

interface hour {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'fury-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [fadeInRightAnimation]
})
export class DashboardComponent implements OnInit {
  isAdmin !: boolean;
  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDate:string = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
  endDate:string = moment(this.today).format('YYYY-MM-DD HH:mm:ss');
  dashboardDetails:any;
  campaignOne = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  campaignTwo = new FormGroup({
    start: new FormControl(new Date(this.year, this.month, 15)),
    end: new FormControl(new Date(this.year, this.month, 19)),
  });
  selectType = new FormGroup({
    type: new FormControl<string | null>('hourType'),
    hourValue: new FormControl(null),
  })
  hours: hour[] = [
    {value: '4hrs', viewValue: '4hrs'},
    {value: '12hrs', viewValue: '12hrs'},
    {value: '24hrs', viewValue: '24hrs'},
    {value: '48hrs', viewValue: '48hrs'},
    {value: '72hrs', viewValue: '72hrs'},
    {value: '7days', viewValue: '7days'},
    {value: '14days', viewValue: '14days'},
    {value: '30days', viewValue: '30days'}
  ];
  constructor(
    private apiService: ApiService,
    private eventService: EventService,
    ) { 
     this.eventService.userData.subscribe((res: UserData)=>{
      this.isAdmin = res.isAdmin;
     });
      
    }

  ngOnInit(): void {
    this.getDashboardData();
  }

  getDashboardData(){
    this.apiService.get(`admin/dashboard/get-dashboard-data?startDate=${this.startDate}&endDate=${this.endDate}&isActive=0`).subscribe((res:any)=>{
     if(res?.body){
      this.dashboardDetails = res?.body;
     }
    }, err =>{
      this.apiService.alert('Something went wrong', 'error');
    })
  };
  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    this.selectType.patchValue({
      hourValue: null
    })
    this.startDate = moment(this.campaignOne.value.start).format('YYYY-MM-DD HH:mm:ss');
    this.endDate = moment(this.campaignOne.value.end).format('YYYY-MM-DD HH:mm:ss');
    this.getDashboardData();
  };
  hourRangeChange(e:any){
    this.campaignOne.patchValue({
      start: null,
      end: null
    })
    if(e.value === '4hrs'){
      this.startDate = moment().subtract(4, "hour").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '12hrs'){
      this.startDate = moment().subtract(12, "hour").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '24hrs'){
      this.startDate = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '48hrs'){
      this.startDate = moment().subtract(2, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '72hrs'){
      this.startDate = moment().subtract(3, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '7days'){
      this.startDate = moment().subtract(7, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '14days'){
      this.startDate = moment().subtract(14, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '30days'){
      this.startDate = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    this.getDashboardData();
  }

  private _gap = 16;
  gap = `${this._gap}px`;


}
